import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useDeleteProductVariant } from "../../../apis";
import { DeleteProductModalProps } from "./DeleteProductModal.types";

import styles from "./DeleteProductModal.module.scss";

const DeleteProductModal = ({
  isOpen,
  id,
  onClose,
  onDeleteSuccess
}: DeleteProductModalProps) => {
  const { t } = useTranslation();

  const {
    isLoading: isLoadingDeleteProductVariant,
    mutate: mutateDeleteProductVariant
  } = useDeleteProductVariant({
    onSuccess: () => {
      onClose();
      onDeleteSuccess();
      toast.success(t("Product variant deleted successfully"));
    }
  });

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title={t("Delete product")}
      isLoading={isLoadingDeleteProductVariant}
      okText="Delete"
      onOk={() => mutateDeleteProductVariant(id)}
      onClose={onClose}
      contentClassName={styles.deleteProduct}
    >
      <p className={styles.deleteProduct_text}>
        {t("Are you sure you want to delete this product?")}
      </p>
    </Modal>
  );
};

export default DeleteProductModal;
